import {
  CLEAN_BILLING_ERROR,
  CLEAN_INSUFFICIENT_FUNDS_ERROR,
  ERROR_CATCH,
  INSUFFICIENT_FUNDS_ERROR_CATCH
} from '../constants/billingErrors';

type Error = {
  data: string | null;
  place: string;
};

export const errorCatch = (error: Error) =>
  ({
    type: ERROR_CATCH,
    error
  } as const);

export const insufficientFundsErrorCatch = (error: Error) =>
  ({
    type: INSUFFICIENT_FUNDS_ERROR_CATCH,
    error
  } as const);

export const cleanBillingError = () =>
  ({
    type: CLEAN_BILLING_ERROR
  } as const);

export const cleanInsufficientFundsError = () =>
  ({
    type: CLEAN_INSUFFICIENT_FUNDS_ERROR
  } as const);

export type Actions =
  | ReturnType<typeof errorCatch>
  | ReturnType<typeof insufficientFundsErrorCatch>
  | ReturnType<typeof cleanBillingError>
  | ReturnType<typeof cleanInsufficientFundsError>;
